import { render, staticRenderFns } from "./lrdjShouYe.vue?vue&type=template&id=12b61b1d&scoped=true"
import script from "./lrdjShouYe.vue?vue&type=script&lang=js"
export * from "./lrdjShouYe.vue?vue&type=script&lang=js"
import style0 from "./lrdjShouYe.vue?vue&type=style&index=0&id=12b61b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b61b1d",
  null
  
)

export default component.exports